import React from 'react';
import PropTypes from 'prop-types';
import { fieldInputPropTypes } from 'redux-form/immutable';

import Input from './Input';

function Checkbox({ input, ...props }) {
  return (
    <Input
      {...props}
      input={{
        ...input,
        onChange: () => input.onChange(!input.value),
        onBlur: () => input.onBlur(input.value),
        checked: !!input.value,
      }}
      type="checkbox"
      defaultValue={false}
    />
  );
}

Checkbox.propTypes = {
  input: PropTypes.shape(fieldInputPropTypes).isRequired,
};

export default Checkbox;
